/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Cc_Position_Bottom_RightInputs */



/**
* | output |
* | --- |
* | "Position Events to the bottom right of the video" |
*
* @param {Shortcut_Keys_Desc_Cc_Position_Bottom_RightInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_cc_position_bottom_right = /** @type {((inputs?: Shortcut_Keys_Desc_Cc_Position_Bottom_RightInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Cc_Position_Bottom_RightInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Positionner les evenements en bas a droite de la video")
	if (locale === "de") return /** @type {LocalizedString} */ ("Positionieren Sie die Ereignisse unten rechts im Video.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Posiziona gli eventi in basso a destra del video")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Разместите события в правом нижнем углу видео.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Colocar eventos en la parte inferior derecha del vídeo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("视频右下角的位置事件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントをビデオの右下に配置する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वीडियो के निचले दाएं कोने में घटनाओं की स्थिति निर्धारित करें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Posicione os eventos no canto inferior direito do vídeo.")
	return /** @type {LocalizedString} */ ("Position Events to the bottom right of the video")
});